import { type ReactNode } from 'react';

import { type Clip } from '@air/api/types';

import {
  DNDMovableToBoardItem,
  type DNDMovableToBoardItemProps,
} from '~/components/Shared/Drag/DNDMovableToBoardItem/DNDMovableToBoardItem';
import { DragType } from '~/components/Shared/Drag/dragTypes';

export type DragDroppableFileShellProps = {
  file: Clip;
  children?: ReactNode;
  index?: number;
  onDragStart?: () => void;
} & Pick<DNDMovableToBoardItemProps, 'onDragStart' | 'enabled'>;

/** Wrapper around a file-related component that enables drag and drop functionality for the target file */
export const DragDroppableFileShell = ({
  /** File object */
  file,
  file: { id, assetId },
  enabled = true,
  children,
  onDragStart,
  index,
  ...rest
}: DragDroppableFileShellProps) => {
  return (
    <DNDMovableToBoardItem
      id={id}
      item={{
        type: DragType.file,
        asset: file,
        assetId,
      }}
      enabled={enabled}
      onDragStart={onDragStart}
      index={index}
      {...rest}
    >
      <>{children}</>
    </DNDMovableToBoardItem>
  );
};
